import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const Text24week = () => {
  const { t } = useTranslation();

  return (
    <div data-bem="Text24week">
      <div className="bottom-text">
        <span>{t('clientConnect.sectionsDescriptionPart1')}</span> {t('clientConnect.section8DescriptionPart2')}
      </div>
    </div>
  );
};

export default Text24week;
